export var EASYBIB = 'easybib';
export var BIBME = 'bibme';
export var CITATION_MACHINE = 'citationmachine';
export var CHEGG = 'chegg';
export var CHEGG_NET = 'cheggnet';
export var CHEGG_SIHP = 'cheggsihp';
export var OWL = 'owl';
export var CITE_THIS_FOR_ME = 'citethisforme';
export var BUSINESS_UNIT = 'wt';
export var GRAMMAR = 'grammar';
export var PLAGIARISM = 'plagiarism';
export var EXPERT_CHECK = 'expert-check';
export var LEFT = 'left';
export var RIGHT = 'right';
export var CENTER = 'center';
export var OAProfileCode;
(function (OAProfileCode) {
  OAProfileCode["CITATION_MACHINE"] = "CM";
  OAProfileCode["BIBME"] = "BM";
  OAProfileCode["EASYBIB"] = "EB";
  OAProfileCode["CHEGG"] = "CHGG";
  OAProfileCode["CITE_THIS_FOR_ME"] = "CTFM";
})(OAProfileCode || (OAProfileCode = {}));
export var SiteDomains;
(function (SiteDomains) {
  SiteDomains["EB"] = ".easybib.com";
  SiteDomains["CTFM"] = ".citethisforme.com";
  SiteDomains["CM"] = ".citationmachine.net";
  SiteDomains["BM"] = ".bibme.org";
  SiteDomains["CHGG"] = ".chegg.com";
})(SiteDomains || (SiteDomains = {}));